var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "uni-course-subject courseAdult" },
    [
      _c(
        "el-row",
        [
          _c("el-col", { attrs: { span: 18 } }, [
            _c("div", { staticClass: "course-box" }, [
              _c("div", { staticClass: "box filter-box" }, [
                _c("ul", { staticClass: "filter-list" }, [
                  _c("li", { staticClass: "item" }, [
                    _c("span", { staticClass: "tit" }, [_vm._v("学习进度")]),
                    _c(
                      "div",
                      _vm._l(_vm.progressMap, function (item, index) {
                        return _c(
                          "el-radio",
                          {
                            key: index,
                            staticClass: "radio",
                            attrs: { label: item.type },
                            on: { change: _vm.typeChange },
                            model: {
                              value: _vm.progress,
                              callback: function ($$v) {
                                _vm.progress = $$v
                              },
                              expression: "progress",
                            },
                          },
                          [_vm._v(_vm._s(item.title))]
                        )
                      }),
                      1
                    ),
                  ]),
                ]),
              ]),
              _c(
                "div",
                { staticClass: "box content-box" },
                [
                  _c(
                    "div",
                    { staticClass: "titleDiv" },
                    [
                      _c(
                        "el-row",
                        [
                          _c("el-col", { attrs: { span: 2 } }, [
                            _c("p", [_vm._v("学期")]),
                          ]),
                          _c("el-col", { attrs: { span: 4 } }, [
                            _c("p", [_vm._v("课程名称")]),
                          ]),
                          _c("el-col", { attrs: { span: 2 } }, [
                            _c("p", [_vm._v("学分")]),
                          ]),
                          _c("el-col", { attrs: { span: 5 } }, [
                            _c("p", [_vm._v("学习进度")]),
                          ]),
                          _c("el-col", { attrs: { span: 8 } }, [
                            _c("p", [_vm._v("操作")]),
                          ]),
                          _c("el-col", { attrs: { span: 3 } }, [
                            _c(
                              "p",
                              { staticStyle: { "border-style": "none" } },
                              [_vm._v("状态")]
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "ul",
                    { staticClass: "course-list" },
                    [
                      _c(
                        "el-row",
                        _vm._l(_vm.specialtyDtos, function (item) {
                          return _c(
                            "li",
                            { key: item.id, staticClass: "item" },
                            [
                              _c("el-col", { attrs: { span: 2 } }, [
                                _c("p", { staticClass: "p" }, [
                                  _vm._v(" " + _vm._s(item.semester) + " "),
                                ]),
                              ]),
                              _c("el-col", { attrs: { span: 4 } }, [
                                _c("div", { staticClass: "itemTitle" }, [
                                  _c("p", { staticClass: "tit" }, [
                                    _vm._v(_vm._s(item.title)),
                                  ]),
                                ]),
                              ]),
                              _c("el-col", { attrs: { span: 2 } }, [
                                _c("p", { staticClass: "p" }, [
                                  _c("span", { staticClass: "num" }, [
                                    _vm._v(_vm._s(item.credit)),
                                  ]),
                                  _vm._v("学分 "),
                                ]),
                              ]),
                              _c("el-col", { attrs: { span: 5 } }, [
                                _c(
                                  "div",
                                  { staticClass: "p" },
                                  [
                                    _c("el-progress", {
                                      staticClass: "progress",
                                      attrs: { percentage: item.percentage },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                              _c("el-col", { attrs: { span: 8 } }, [
                                item.is_start == 1 && item.act_status == 1
                                  ? _c("div", { staticClass: "itemButton" }, [
                                      _c(
                                        "button",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.goRouter(
                                                "subjectAdult",
                                                item
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("em", {
                                            staticClass: "iconfont iconshipin",
                                          }),
                                          _c("span", [_vm._v("去学习")]),
                                        ]
                                      ),
                                      item.course_type == 4 ||
                                      (item.percentage == 100 &&
                                        item.exam_type == 2 &&
                                        (item.exam_status == 1 ||
                                          item.exam_status == 2 ||
                                          item.exam_status == 6))
                                        ? _c(
                                            "button",
                                            {
                                              on: {
                                                click: function ($event) {
                                                  return _vm.goRoExam(item)
                                                },
                                              },
                                            },
                                            [
                                              _c("em", {
                                                staticClass:
                                                  "iconfont iconicon f14",
                                              }),
                                              _c("span", [_vm._v("去考试")]),
                                            ]
                                          )
                                        : _vm._e(),
                                    ])
                                  : _c("div", { staticClass: "itemButton" }, [
                                      _vm._v("未开放"),
                                    ]),
                              ]),
                              _c("el-col", { attrs: { span: 3 } }, [
                                item.exam_status == 0
                                  ? _c(
                                      "span",
                                      {
                                        staticClass: "p",
                                        style: _vm._f("paperColor")(
                                          item.rate_type
                                        ),
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.progressMap[item.rate_type]
                                                .title
                                            ) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                item.exam_status > 0
                                  ? _c(
                                      "span",
                                      {
                                        staticClass: "p",
                                        style: _vm._f("examStatusColor")(
                                          item.exam_status
                                        ),
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.courseExamStatusMap[
                                                item.exam_status
                                              ]
                                            ) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]),
                            ],
                            1
                          )
                        }),
                        0
                      ),
                    ],
                    1
                  ),
                  _vm.specialtyDtos.length == 0
                    ? _c("ComponentEmpty", {
                        attrs: { title: "暂无课程", tips: "" },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ]),
          ]),
          _c("el-col", { attrs: { span: 6 } }, [
            _vm.studentMajor
              ? _c("div", { staticClass: "side-box" }, [
                  _c("div", { staticClass: "box info-box" }, [
                    _c("h2", { staticClass: "title" }, [
                      _vm._v(_vm._s(_vm.studentMajor.professionName)),
                    ]),
                    _c("div", { staticClass: "mat40 text-center" }, [
                      _c("img", {
                        staticStyle: { width: "60%" },
                        attrs: {
                          src: require("@/assets/images/undraw_Upvote_re_qn2k.png"),
                          alt: "",
                        },
                      }),
                    ]),
                    _c("div", { staticClass: "banner-box" }, [
                      _c("h3", { staticClass: "h3" }, [_vm._v("专业学习说明")]),
                      _c("div", {
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.studentMajor.profession_content
                          ),
                        },
                      }),
                    ]),
                  ]),
                ])
              : _vm._e(),
          ]),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "tips-box" },
        [
          _c(
            "el-dialog",
            {
              attrs: {
                title: "温馨提示：",
                visible: _vm.isShowTips,
                "close-on-click-modal": false,
                "show-close": false,
                width: "800px",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.isShowTips = $event
                },
                close: _vm.tipsClose,
              },
            },
            [
              _c("div", { staticClass: "cont" }, [
                _c("div", { staticClass: "text-box" }, [
                  _c("p", { staticClass: "text" }, [
                    _vm._v(
                      "您即将进入在线考试，请务必仔细阅读以下注意事项，确保考试顺利进行："
                    ),
                  ]),
                  _c("p", { staticClass: "text yuan" }, [
                    _c("span", { staticClass: "bold red" }, [
                      _vm._v("请先强制刷新浏览器"),
                    ]),
                    _vm._v(
                      " （可按 Ctrl + F5），清除缓存，确保页面为最新版本，避免因加载异常影响答题。 "
                    ),
                  ]),
                  _c("p", { staticClass: "text yuan" }, [
                    _c("span", { staticClass: "bold red" }, [
                      _vm._v("考试时长为2小时"),
                    ]),
                    _vm._v(
                      " ，计时从您点击“开始考试”后自动开始，一旦启动，时间将持续计算，不可暂停。 "
                    ),
                  ]),
                  _c("p", { staticClass: "text yuan" }, [
                    _vm._v(" 考试过程中 "),
                    _c("span", { staticClass: "bold red" }, [
                      _vm._v("禁止使用复制、粘贴、截图等操作"),
                    ]),
                    _vm._v(" ，系统将记录相关行为，违规将影响成绩。 "),
                  ]),
                  _c("p", { staticClass: "text yuan" }, [
                    _c("span", { staticClass: "bold red" }, [
                      _vm._v(
                        "考试开始后，无论是否退出页面或关闭浏览器，倒计时均照常进行"
                      ),
                    ]),
                    _vm._v(
                      " ，2小时结束后系统将自动交卷，请合理安排答题时间。 "
                    ),
                  ]),
                  _c("p", { staticClass: "text yuan" }, [
                    _c("span", { staticClass: "bold red" }, [
                      _vm._v("“实践课程”先在“去学习”页面里下载课件"),
                    ]),
                    _vm._v(" ，根据课件内容完成实践作业后，再进行考试提交 "),
                  ]),
                  _c("p", { staticClass: "text yuan" }, [
                    _vm._v(
                      "建议您在稳定的网络环境中作答，并使用推荐的浏览器（如：“谷歌浏览器” 最新版），避免意外中断"
                    ),
                  ]),
                  _c("p", { staticClass: "text" }, [
                    _vm._v("请确认准备就绪后再开始考试，祝您发挥出色！"),
                  ]),
                ]),
                _c(
                  "div",
                  {
                    staticStyle: {
                      "margin-top": "50px",
                      display: "flex",
                      "justify-content": "space-between",
                      "align-items": "center",
                    },
                  },
                  [
                    _c(
                      "div",
                      [
                        _c(
                          "el-checkbox",
                          {
                            attrs: { disabled: !_vm.isConfirm },
                            model: {
                              value: _vm.isReading,
                              callback: function ($$v) {
                                _vm.isReading = $$v
                              },
                              expression: "isReading",
                            },
                          },
                          [_vm._v("我已阅读")]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      [
                        _c(
                          "el-button",
                          {
                            on: {
                              click: function ($event) {
                                _vm.isShowTips = false
                              },
                            },
                          },
                          [_vm._v("取 消")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: {
                              type: "primary",
                              disabled: !_vm.isConfirm,
                            },
                            on: { click: _vm.confirmExamClick },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.isConfirm ? "确认考试" : _vm.timeNum + "秒"
                              )
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]
                ),
              ]),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }